<template>
  <div class="hp-manager-page-list">
    <filter-form :filter="filter" @handleSubmit="handleSubmit">
    </filter-form>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :indentSize="15" :dataSource="datas" :pagination="pagination" :loading="loading" @tableChange="tableChange">
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a @click="handleEdit(2,rowKey.data)" :disabled="!permissionChecker('Feedback.Query')" v-if=" rowKey.data.hasReply==true">查看</a>
          <a @click="handleEdit(1,rowKey.data)" :disabled="!permissionChecker('Feedback.Reply')" v-else>回复</a>
        </span>
      </template>
    </standard-table>

    <!-- 新增修改弹窗 -->
    <hp-manager-modal :width="modalWidth" :title="title" v-model="addVisible">
      <hp-manager-page-feedback-reply slot="slot" @submit-success="refreshCurrent" @cancel="addVisible = false" :params="params"></hp-manager-page-feedback-reply>
    </hp-manager-modal>
  </div>
</template>

<script>
import { api } from "@/common";

import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import hpManagerPageFeedbackReply from "./Reply";
import config from "@/config";
import { setTimeout } from "timers";

export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {
    hpManagerPageFeedbackReply
  },
  data() {
    return {
      filter: [
        {
          type: "dateFilter",
          key: "filterTime",
          name: "创建时间"
        },
        {
          type: "select",
          key: "hasReply",
          name: "是否回复",
          options: [
            { name: "已回复", val: true },
            { name: "未回复", val: false }
          ]
        }
      ],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 80,
          scopedSlots: { customRender: "action" }
        },
        {
          title: "内容",
          dataIndex: "content",
          customRender: (text, row, index) => {
            return row.content.length > 200
              ? row.content.substring(0, 200) + "..."
              : row.content;
          }
        },
        {
          title: "创建人",
          width: 150,
          dataIndex: "creationUserName"
        },
        {
          title: "创建时间",
          width: 150,
          dataIndex: "creationTime",
          sorter: true,
          customRender: (text, row, index) => {
            return this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss");
          }
        },
        {
          title: "是否回复",
          width: 150,
          dataIndex: "hasReply",
          customRender: (text, row, index) => {
            return row.hasReply == true ? "已回复" : "未回复";
          }
        },
        {
          title: "回复时间",
          width: 150,
          dataIndex: "replyTime",
          customRender: (text, row, index) => {
            return row.hasReply == true
              ? this.formatDate(row.replyTime, "YYYY-MM-DD HH:mm:ss")
              : "";
          }
        }
      ],
      datas: [],
      filterdata: Object.assign(
        {
          creationStartTime: null,
          creationEndTime: null,
          hasReply: null
        },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      addVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "800px",

      permission: [],
      title: ""
    };
  },
  async mounted() {
    this.permission = this.getPermission("Feedback");

    this.getDatas(this.filterdata);
  },
  methods: {
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.creationStartTime =
        p.values.filterTime[0] != null
          ? p.values.filterTime[0].startOf("day").valueOf()
          : null;
      this.filterdata.creationEndTime =
        p.values.filterTime[1] != null
          ? p.values.filterTime[1].startOf("day").valueOf()
          : null;
      this.filterdata.hasReply = p.values.hasReply;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    //弹出编辑 详情 新增 模态框
    handleEdit(type, record) {
      this.isabl = false;
      if (type == 1) {
        this.title = "回复";
      } else if (type == 2) {
        this.title = "反馈信息";
        this.isabl = true;
      } else {
        this.title = "反馈信息";
      }
      this.params = Object.assign({ isShow: this.isabl }, record);
      this.addVisible = true;
    },
    refreshCurrent() {
      this.pagination.current = 0;
      this.addVisible = false;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.filters.code && table.filters.code.length > 0) {
        console.log(table.filters);
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      let data = await api.GetFeedbackList(options);
      this.datas = data.items;
      console.log(data);
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Information/Feedback/List.vue